export default __webpack_public_path__ + "static/media/trash-g.84655b6b.svg";